import { CSSProperties } from '@material-ui/styles';

const textWithEllipsisStyle: CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export default textWithEllipsisStyle;
